const spacing = {
  '1': 4,
  '7.5': 30,
}

export default spacing
